import React from 'react';
import SiteIcon from './SiteIcon';
import './LaunchOffer.css';

export const STARTER_SERVICE = 'Business website — £100';
const PHONE = '+447711804361';
const WHATSAPP = 'https://wa.me/447711804361?text=' + encodeURIComponent('Hi Lukasz, I saw Taldigi and would like to discuss a website for my business.');

export function LaunchHeroCopy({ onEnquire }) {
  return <div className="hero-copy launch-hero-copy">
    <p className="eyebrow"><span className="status-dot" /> STARTING A BUSINESS? START HERE.</p>
    <h1>Your business.<br />Your website.<br /><em className="launch-price">From £100.</em></h1>
    <div className="launch-growth-scene"><img
      className="launch-growth-image"
      src="/images/startup/website-presentation-side-1440.webp"
      srcSet="/images/startup/website-presentation-side-720.webp 720w, /images/startup/website-presentation-side-1440.webp 1440w"
      sizes="(max-width: 700px) calc(100vw - 36px), (max-width: 1000px) 48vw, 600px"
      width="1440"
      height="600"
      fetchpriority="high"
      alt="A developer and client viewed from the side, looking at the same website on a laptop, tablet and phones facing them."
    /></div>
    <p className="lead">Give your idea a place online. Professional websites for start-ups, sole traders and small businesses — designed around you, with a budget you can start with.</p>
    <div className="hero-actions">
      <a href="#contact" className="button primary" onClick={() => onEnquire(STARTER_SERVICE)}>Start my website <SiteIcon /></a>
      <a href="#work" className="text-link">See the websites <SiteIcon /></a>
    </div>
    <p className="launch-terms">One-off starter website build. Domain and hosting agreed separately.</p>
    <div className="hero-foot"><span>Winchester, UK</span><span>Websites</span><span>Apps & AI</span></div>
  </div>;
}

export function LaunchOffer({ onEnquire }) {
  return <section className="wrap launch-offer" id="starter" aria-labelledby="starter-title">
    <div className="launch-package">
      <div className="launch-package-copy">
        <p className="eyebrow">A SMALL START. ROOM TO GROW.</p>
        <h2 id="starter-title">Open for business.<br />Ready to be found.</h2>
        <p>Starting a salon, a trade, a local service or something entirely your own? Give customers one clear place to see what you do and get in touch.</p>
        <div className="launch-package-price"><span>Starter website from</span><strong>£100</strong><span>one-off build</span></div>
        <a href="#contact" className="button primary" onClick={() => onEnquire(STARTER_SERVICE)}>Ask about the £100 website <SiteIcon /></a>
      </div>
      <div className="launch-inclusions">
        <h3>Your essentials, beautifully put together.</h3>
        <ul>{[
          'One responsive page for phones, tablets and desktops',
          'Your business, services and photographs',
          'Your colours, your style and your story',
          'An enquiry form and clear contact details',
          'A location map and basic search metadata'
        ].map(item => <li key={item}><SiteIcon name="check" /><span>{item}</span></li>)}</ul>
        <p className="launch-scope">The £100 starting price covers a basic one-page website with an agreed scope. Domain, hosting, ongoing changes, extra pages, bookings and payment systems are quoted separately before work begins.</p>
      </div>
    </div>
    <ol className="launch-steps" aria-label="How your website gets built">
      <li><span>01</span><div><h3>Tell me your idea.</h3><p>Your business, what you offer and the look you love.</p></div></li>
      <li><span>02</span><div><h3>Agree the details.</h3><p>We confirm the pages, content, price and timescale.</p></div></li>
      <li><span>03</span><div><h3>Review. Launch. Share.</h3><p>Check your website, then give your business a link to share.</p></div></li>
    </ol>
  </section>;
}

export function ContactLinks() {
  return <div className="launch-contact-links">
    <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="button primary">Let’s talk on WhatsApp <SiteIcon /></a>
    <a className="launch-phone" href={'tel:' + PHONE}><SiteIcon name="phone" /> 07711 804361</a>
    <p>Talk directly to Lukasz · English, Polski, Español</p>
  </div>;
}
